<template>
  <div class="table-container stocks">
    <div class="table-container-buttons">
      <v-btn
        class="text-capitalize"
        color="green lighten-1"
        @click="openCreateModal()"
      >
        <v-icon color="white" small>mdi-plus-circle-outline</v-icon>
        <span class="table-container-buttons__text">Добавить</span>
      </v-btn>
      <v-btn
        :disabled="!selectedItems.length"
        class="text-capitalize"
        color="error"
        @click="deleteSelected()"
      >
        <v-icon color="white" small>mdi-trash-can-outline</v-icon>
        <span class="table-container-buttons__text">Удалить выбранное</span>
      </v-btn>
    </div>
    <div class="table-container-wrapper">
      <div class="table-container-wrapper-header">
        <div class="table-container-wrapper-header__views">
          Показать
          <v-select
            v-model="selectedCount"
            :items="changeCount"
            :menu-props="{ bottom: true, offsetY: true }"
            dense
            height="20"
            hide-details
            solo
          ></v-select>
          записей
        </div>
        <div class="table-container-wrapper-header__search">
          Поиск:
          <v-text-field dense height="20" hide-details label="" solo></v-text-field>
        </div>
      </div>
      <table class="table-container-wrapper-main">
        <thead class="table-container-wrapper-main-header">
          <tr>
            <th class="table-container-wrapper-main-header__title">
              <v-checkbox
                class="table-container-wrapper-main-header__title__checkbox"
                dense
                hide-details
                @click="selectAll()"
              ></v-checkbox>
            </th>
            <th
              v-for="(title, index) in titles"
              :key="index"
              class="table-container-wrapper-main-header__title"
              data-type="text-short"
            >
              <span class="table-container-wrapper-main-header__title__text">{{
                title.TEXT
              }}</span>
            </th>
            <th class="table-container-wrapper-main-header__title actions">
              <span class="table-container-wrapper-main-header__title__text">Доступные действия</span>
            </th>
          </tr>
        </thead>
        <tbody class="table-container-wrapper-main-items">
          <tr v-for="(row, index) in listItems" :key="index">
            <td>
              <v-checkbox
                v-model="row.SELECTED"
                dense
                hide-details
                @click="setSelect(row)"
              ></v-checkbox>
            </td>
            <td>{{ row.code }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.ids_specifications && row.ids_specifications.length || 0 }}</td>
            <td>{{ row._company && row._company.name }}</td>
            <td>{{ row._city && row._city.city }}</td>
            <td>{{ row.created_at }}</td>
            <td class="buttons">
              <v-btn
                class="text-capitalize"
                color="blue lighten-1"
                style="font-size: 12px"
                @click="onEditCard(row)"
              >
                <v-icon color="white" small>mdi-pencil-box-multiple</v-icon>
                <span class="table-container-buttons__text">Изменить</span>
              </v-btn>
              <v-btn
                class="text-capitalize"
                color="error"
                @click="onDelCard(row)"
              >
                <v-icon color="white" small>mdi-trash-can</v-icon>
                <span class="table-container-buttons__text">Удалить</span>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- MODAL -->
    <v-dialog
      v-model="showCard"
      width="1200"
      persistent
      @keydown.stop.esc="closeCreateModal"
      @click:outside.stop="closeCreateModal"
    >
      <v-card>
        <v-card-title>
          <span class="text-h6" style="font-size: 0.8em !important">
            Создать/редактировать пример работ
          </span>
          <v-spacer />
          <v-btn
            icon
            :disabled="$store.state.loadingRequestGeneral"
            @click="closeCreateModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <PrimeryKotelnyhEditor v-if="showCard" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DELETE DIALOG -->
    <v-dialog
      v-model="delCard"
      max-width="600"
      @keydown.esc="sayModalNoDeleteCard"
      @click:outside="sayModalNoDeleteCard"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Вы точно хотите удалить эту запись?</span>
        </v-card-title>
        <v-card-text>
          {{ curEntry.name }} будет удалена вместе со всеми фотографиями и метками
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteCard()">Да</v-btn>
          <v-btn color="blue darken-1" text @click="sayModalNoDeleteCard()">Нет</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import PrimeryKotelnyhEditor from "@/components/primery-kotelnyh/PrimeryKotelnyhEditor.vue";

export default {
  name: "PrimeryKotelnyh",
  components: { PrimeryKotelnyhEditor },
  data: () => ({
    titles: [
      { TEXT: "Код (url)" },
      { TEXT: "Название" },
      { TEXT: "Фото" },
      { TEXT: "Компания" },
      { TEXT: "Город" },
      { TEXT: "Дата создания" },
    ],
    changeCount: [5, 10, 15, 20, 25],
    selectedCount: 10,
    selectedItems: [],
    showCard: false,
    delCard: false,
  }),
  created() {
    this.getListEntries();
  },
  computed: {
    ...mapState({
      listItems: (state) => state.PrimeryKotelnyh.listEntries,
    }),
    curEntry: {
      get() {
        return this.$store.state.PrimeryKotelnyh.entry;
      },
      set(value) {
        this.$store.commit("PrimeryKotelnyh/setEntryData", value);
      },
    },
  },
  methods: {
    ...mapActions("PrimeryKotelnyh", ["getListEntries", "deleteEntry", "clearEntry"]),
    ...mapMutations("PrimeryKotelnyh", ["setEntryData", "clearEntry"]),
    openCreateModal() {
      this.clearEntry();
      this.showCard = true;
    },
    async deleteSelected() {
      if (!this.selectedItems.length) return;
      for (const id of this.selectedItems) {
        this.setEntryData({ id });
        await this.deleteEntry();
      }
      this.selectedItems = [];
      await this.getListEntries();
    },
    selectAll() {
      if (this.allSelected) {
        this.listItems.forEach((elem) => (elem.SELECTED = false));
        this.selectedItems = [];
        this.allSelected = false;
      } else {
        this.listItems.forEach((elem) => {
          elem.SELECTED = true;
          this.selectedItems.push(elem.id);
        });
        this.allSelected = true;
      }
    },
    setSelect(row) {
      if (row.SELECTED) {
        this.selectedItems.push(row.id);
      } else {
        const index = this.selectedItems.findIndex((i) => i === row.id);
        if (index !== -1) this.selectedItems.splice(index, 1);
      }
    },
    onEditCard(row) {
      this.setEntryData(row);
      this.showCard = true;
    },
    onDelCard(row) {
      this.delCard = true;
      this.setEntryData(row);
    },
    async closeCreateModal() {
      if (this.$store.state.loadingRequestGeneral) return;
      this.showCard = false;
      this.clearEntry();
      await this.getListEntries();
    },
    async deleteCard() {
      await this.deleteEntry();
      await this.getListEntries();
      this.sayModalNoDeleteCard();
    },
    sayModalNoDeleteCard() {
      this.delCard = false;
      this.clearEntry();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container-wrapper-main {
  grid-template-columns: auto 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}
</style>